export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';

export const resetPasswordRequest = ({ password, hash, confirmationHash }) => ({
    type: RESET_PASSWORD_REQUEST,
    payload: { password, hash, confirmationHash }
});
